import styled, { keyframes } from 'styled-components';
import { ProgressCircleHalf } from '@alefeducation/ui-elements-library-icons';

const StyledSpin = keyframes`
  0% {
    transform: rotate(0deg);
  }

  100% {
    transform: rotate(359deg);
  }
`;

const StyledIcon = styled(ProgressCircleHalf)`
  font-size: 60px;
  animation: ${StyledSpin} 1s infinite linear;
`;

const StyledLoadingContainer = styled.div`
  height: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
`;

const Loading = (props: any) => (
  <StyledLoadingContainer data-testid="loading" {...props}>
    <StyledIcon color="success.100" />
  </StyledLoadingContainer>
);

export default Loading;
